import { SystemUiconsMailNew } from '../../../../assets/icons/Icons'

interface ClientModalAddIconWrapProps {
    onClick: () => void
}

export default function ClientModalAddIconWrap({ onClick }: ClientModalAddIconWrapProps) {

    return (
        <div className='cursor-pointer flex justify-center items-center'>
            <span onClick={onClick} className='p-3 bg-gray-300 rounded-lg'>
                <SystemUiconsMailNew color='#aaadab' height={33} width={33} />
            </span>
        </div>
    )
}
